import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Login from "./login";
import LandingPage from "./landingpage";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
  <App/>
    {/* <Login />  */}
     {/* <LandingPage />  */}
  </React.StrictMode>
);
